import {
  startOfDay,
  addDays,
  addMonths,
  differenceInDays,
  startOfMonth,
  isBefore,
  isEqual,
} from "date-fns"
import { WorkdaysQuery } from "../Workdays/Workdays.generated"

export interface IWorkDaysResult {
  defaultActivationDate: Date | undefined
  defaultActivationHour: number
  possibleActivationHours: number[]
  workdays: Date[] | undefined
  workHours: number[]
  lastPossiblePortingDate: Date | undefined
  disabledDays: Date[]
}

function isDateBeforeToday(dateStart: Date, firstValidDate = new Date()) {
  return isBefore(dateStart, firstValidDate)
}

// Notat fra Runar 1. Aug. 2022:
//
// Jeg har ingen aning om hvordan denne funksjonen skal fungere, men jeg har
// refaktorisert den basert på eksempeldata. Jeg la til en test for dette, med
// noe data, og gjenskapte slik at testen gikk gjennom. Jeg tror dette er
// riktig, men kan ikke garantere det.

const workHours: number[] = [9, 10, 11, 12, 13, 14, 15]
const allHours: number[] = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
]
export const calculateWorkdaysData = ({
  workDaysData,
  nbOfWorkdaysToSkip = 0,
  excludeRedDays = false,
  lastPossiblePortingDate = null,
  allowAllHours = false,
}: {
  workDaysData: null | undefined | WorkdaysQuery
  nbOfWorkdaysToSkip?: number
  excludeRedDays: boolean
  lastPossiblePortingDate: null | undefined | Date
  allowAllHours?: boolean | undefined
}): IWorkDaysResult => {
  const now = new Date()
  const dToday = startOfDay(now)
  let dCounter = startOfMonth(now)
  const calculatedLastPossiblePortingDate = addDays(addMonths(dCounter, 12), -1)
  const dLastPossiblePortingDate =
    !!lastPossiblePortingDate &&
    lastPossiblePortingDate < calculatedLastPossiblePortingDate
      ? lastPossiblePortingDate
      : calculatedLastPossiblePortingDate
  let firstValidDate: Date | undefined = undefined
  const disabledDays: Date[] = []
  let workdays = workDaysData?.workdays?.map((wd) => new Date(wd))

  if (workdays) {
    let loops = 0
    // while (lastPossiblePortingDate.diff(dateCounter, "days") >= 0) {
    while (differenceInDays(dLastPossiblePortingDate, dCounter) >= 0) {
      loops++
      if (loops > 2000) {
        throw new Error("too many loops!!!!")
      }
      if (isDateBeforeToday(dCounter, dToday)) {
        // Disabling all days before today
        disabledDays.push(dCounter)
      } else if (
        excludeRedDays &&
        /* eslint-disable-next-line no-loop-func */
        workdays?.every((wd) => !isEqual(new Date(wd), dCounter))
      ) {
        // Disabling all days that are not found in the workdays array.
        disabledDays.push(dCounter)
      } else if (nbOfWorkdaysToSkip > 0) {
        // Skipping ie. the first 5 workdays
        disabledDays.push(dCounter)
        nbOfWorkdaysToSkip--
      } else if (firstValidDate === undefined) {
        // Now we have reached the first valid date :)
        firstValidDate = dCounter
      }
      dCounter = addDays(dCounter, 1)
    }
  }

  return {
    defaultActivationDate: firstValidDate,
    defaultActivationHour: 10,
    possibleActivationHours: allowAllHours ? allHours : workHours,
    workdays: workdays,
    workHours: allowAllHours ? allHours : workHours,
    lastPossiblePortingDate: dLastPossiblePortingDate,
    disabledDays: disabledDays,
  }
}
